/*  camelcase */
export default {
    reason: ['required', 'trim', 'string'],
    write_off_products: ['required', 'trim', 'string'],
    guilty: ['required', 'trim', 'string'],
    duplicate_order: ['required', 'trim', 'string'],
};